type Product = {
  name?: string;
  idproducts?: number;
};

type Regulation = {
  label: string;
  url: string;
};

type RegulationsById = {
  ids: number[];
  regulations: Regulation[];
};

type RegulationsByName = {
  namePattern: RegExp;
  regulations: Regulation[];
};

const regulationsById: RegulationsById[] = [
  {
    // karta-magnetyczna-pluxee-prezent-na-raz
    // karta-magnetyczna-pluxee-prezent-na-swieta-wielkanoc-na-raz
    // pluxee-prezent-dla-dzieci-na-raz
    // karta-wirtualna-pluxee-prezent-na-raz
    // karta-wirtualna-pluxee-prezent-na-swieta-wielkanoc-na-raz
    // karta-magnetyczna-pluxee-prezent-na-swieta-na-raz-bn
    // karta-wirtualna-pluxee-prezent-na-swieta-na-raz
    ids: [30192, 30416, 30418, 30143, 30414, 30937, 30174],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Prezent_na_raz!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://www.pluxee.pl/sites/g/files/jclxxe406/files/2026-09/Regulamin-Pluxee-Prezent-na-raz-PL-EN-250919.pdf',
      },
    ],
  },
  {
    // karta-zblizeniowa-pluxee-prezent-na-maxa
    // karta-zblizeniowa-pluxee-prezent-na-swieta-wielkanoc-na-maxa
    // karta-zblizeniowa-pluxee-prezent-na-swieta-na-maxa
    // karta-wirtualna-pluxee-prezent-na-maxa
    // karta-wirtualna-pluxee-prezent-na-maxa-na-swieta
    ids: [30670, 30818, 30702, 30667, 30675],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Prezent_na_maxa!_PL_EN.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Prezent_na_maxa!PL_250314.pdf',
      },
    ],
  },
  {
    // karta-magnetyczna-pluxee-nagroda-na-raz
    // karta-magnetyczna-pluxee-nagroda-na-raz-wazna-6-miesiecy
    // karta-wirtualna-pluxee-nagroda-na-raz
    // karta-wirtualna-pluxee-nagroda-na-raz-wazna-6-miesiecy
    ids: [30193, 30417, 30144, 30341],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Nagroda_na_raz!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Nagroda_na_raz!PL_250314.pdf',
      },
    ],
  },
  {
    // karta-zblizeniowa-pluxee-nagroda-na-maxa
    // karta-wirtualna-pluxee-nagroda-na-maxa
    ids: [30662, 30659],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Nagroda_na_maxa!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Nagroda_na_maxa!PL_250314.pdf',
      },
    ],
  },
  {
    // karta-zblizeniowa-pluxee-lunch-24-miesiace
    // karta-zblizeniowa-pluxee-lunch-36-miesiecy
    // karta-zblizeniowa-pluxee-lunch-24-msc
    // karta-zblizeniowa-pluxee-lunch-36-msc
    // karta-wirtualna-pluxee-lunch-24-miesiace
    // karta-wirtualna-pluxee-lunch-36-miesiecy
    // karta-wirtualna-pluxee-lunch-24-msc
    // karta-wirtualna-pluxee-lunch-36-msc
    ids: [30676, 30681, 30853, 30846, 30686, 30687, 30851, 30852],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Lunch_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Lunch_PL_250314.pdf',
      },
    ],
  },
  {
    // karta-zblizeniowa-pluxee-posilek-24-miesiace
    // karta-zblizeniowa-pluxee-posilek-36-miesiecy
    ids: [30688, 30707],
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://www.pluxee.pl/sites/g/files/jclxxe406/files/2026-02/og%C3%B3lne-warunki-sprzeda%C5%BCy-pluxee-posi%C5%82ek_240804.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://eddie.pluxee.pl/sites/g/files/jclxxe406/files/2025-02/Regulamin_karty_Pluxee_Posi%C5%82ek_240801.pdf',
      },
    ],
  },
];

const regulationsByName: RegulationsByName[] = [
  {
    namePattern: /Prezent na raz!/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Prezent_na_raz!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Prezent_na_raz!PL_250314.pdf',
      },
    ],
  },
  {
    namePattern: /Prezent na maxa!/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Prezent_na_maxa!_PL_EN.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Prezent_na_maxa!PL_250314.pdf',
      },
    ],
  },
  {
    namePattern: /Nagroda na raz!/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Nagroda_na_raz!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Nagroda_na_raz!PL_250314.pdf',
      },
    ],
  },
  {
    namePattern: /Nagroda na maxa!/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Nagroda_na_maxa!_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Nagroda_na_maxa!PL_250314.pdf',
      },
    ],
  },
  {
    namePattern: /Lunch(?! 2\.0)|Hobby/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/OWS%202025/OWS_Lunch_PL_250314.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://7768293.fs1.hubspotusercontent-na1.net/hubfs/7768293/www.pluxee.pl/Panel%20klienta%20B2B/Regulaminy%20kart%20i%20kupon%C3%B3w/Regulaminy%20kart%20Pluxee%202025/Regulamin_Pluxee_Lunch_PL_250314.pdf',
      },
    ],
  },
  {
    namePattern: /Lunch 2.0/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://www.pluxee.pl/sites/g/files/jclxxe406/files/2026-09/OWS-Pluxee-Lunch-PL-EN-260402.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://www.pluxee.pl/sites/g/files/jclxxe406/files/2026-09/Regulamin-Pluxee-Lunch-PL-EN-260402.pdf',
      },
    ],
  },
  {
    namePattern: /Posiłek/i,
    regulations: [
      {
        label: 'Ogólnymi Warunkami Sprzedaży („OWS”)',
        url:
          'https://www.pluxee.pl/sites/g/files/jclxxe406/files/2026-02/og%C3%B3lne-warunki-sprzeda%C5%BCy-pluxee-posi%C5%82ek_240804.pdf',
      },
      {
        label: 'Regulaminem korzystania z Karty',
        url:
          'https://eddie.pluxee.pl/sites/g/files/jclxxe406/files/2025-02/Regulamin_karty_Pluxee_Posi%C5%82ek_240801.pdf',
      },
    ],
  },
];

export function resolveIndividualRegulations(product?: Product): Regulation[] {
  const { idproducts: productId, name } = product || {};
  if (!productId) return [];

  const byId = regulationsById.filter(g => g.ids.includes(productId)).flatMap(g => g.regulations);
  if (byId.length > 0) return byId;

  if (!name) return [];
  return regulationsByName.filter(g => g.namePattern.test(name)).flatMap(g => g.regulations);
}
